import { Loader2, AlertTriangle, Inbox } from "lucide-react";
import { Button } from "../ui/button";

export const Loader = ({ label = "Chargement…" }) => (
  <div data-testid="loader" className="flex items-center justify-center gap-2 py-16 text-sm text-slate-500">
    <Loader2 className="h-4 w-4 animate-spin" /> {label}
  </div>
);

export const ErrorState = ({ message, onRetry }) => (
  <div data-testid="error-state" className="card-surface flex flex-col items-center gap-3 p-10 text-center">
    <AlertTriangle className="h-6 w-6 text-rose-600" />
    <p className="text-sm text-slate-700">{message}</p>
    {onRetry && (
      <Button variant="outline" size="sm" onClick={onRetry} data-testid="error-retry-button">Réessayer</Button>
    )}
  </div>
);

export const EmptyState = ({ icon: Icon = Inbox, title, text, action }) => (
  <div data-testid="empty-state" className="flex flex-col items-center gap-2 rounded-xl border border-dashed border-slate-300 bg-white/60 px-6 py-14 text-center">
    <Icon className="h-7 w-7 text-slate-400" />
    <p className="font-display font-semibold text-slate-800">{title}</p>
    {text && <p className="max-w-md text-sm text-slate-500">{text}</p>}
    {action && <div className="mt-3">{action}</div>}
  </div>
);

export const PageHeader = ({ eyebrow, title, description, actions }) => (
  <div className="mb-8 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
    <div>
      {eyebrow && <p className="eyebrow mb-2">{eyebrow}</p>}
      <h1 className="font-display text-2xl font-bold tracking-tight text-slate-900 sm:text-3xl" data-testid="page-title">{title}</h1>
      {description && <p className="mt-1.5 max-w-2xl text-sm text-slate-500">{description}</p>}
    </div>
    {actions && <div className="flex flex-wrap gap-2">{actions}</div>}
  </div>
);

export const FieldError = ({ children }) =>
  children ? <p className="mt-1 text-xs font-medium text-rose-600">{children}</p> : null;
